import variantPicker from "./variant-picker.js";

export default () => ({
  isOpen: false,
  productUrl: null,
  productHtml: null,
  loading: false,

  init() {
    this.productHtml = null;
    window.Alpine.data("variantPicker", variantPicker);
  },

  toggle(event) {
    // Handle opening with new product
    if (event?.detail) {
      this.productUrl = event.detail;

      // Only prevent scrolling if quick view is not already open
      if (!this.isOpen) {
        this.isOpen = true;
        this.$store.quickview.toggle(this.productUrl);
        // Prevent scrolling of underlying content
        if (window.ShopSuey && window.ShopSuey.noScroll) {
          window.ShopSuey.noScroll(true);
        }
      } else {
        // Quick view is already open, just update the store
        this.$store.quickview.toggle(this.productUrl);
      }

      this.loadProduct();
    }
    // Handle closing
    else {
      this.isOpen = false;
      this.$store.quickview.toggle(null);

      // Re-enable scrolling of underlying content
      if (window.ShopSuey && window.ShopSuey.noScroll) {
        window.ShopSuey.noScroll(false);
      }

      // Reset state when closing
      this.productUrl = null;
      this.productHtml = null;
      const contentDiv = document.getElementById("quick-view-content");
      if (contentDiv) contentDiv.innerHTML = "";
    }
  },

  close() {
    this.toggle();
  },

  async loadProduct() {
    if (!this.productUrl) return;

    try {
      this.loading = true;
      this.productHtml = null;

      // Use Shopify's sections API to get both product data and rendered sections
      const [productResponse, sectionsResponse] = await Promise.all([
        fetch(`${this.productUrl}.js`),
        fetch(`${this.productUrl}?sections=quick-view-content`)
      ]);

      if (!productResponse.ok || !sectionsResponse.ok) {
        throw new Error("Failed to load product");
      }

      const [productData, sections] = await Promise.all([productResponse.json(), sectionsResponse.json()]);

      // Update global product data if needed
      window.productData = productData;

      const contentDiv = document.getElementById("quick-view-content");
      if (contentDiv && sections["quick-view-content"]) {
        contentDiv.innerHTML = sections["quick-view-content"];
        this.productHtml = sections["quick-view-content"];

        // Re-init any needed components
        if (window.reinitProductComponents) {
          window.reinitProductComponents(contentDiv);
        }
      }
    } catch (error) {
      const contentDiv = document.getElementById("quick-view-content");
      if (contentDiv) {
        contentDiv.innerHTML = '<p class="p-gutter-16 text-error">Failed to load product</p>';
        this.productHtml = "error";
      }
    } finally {
      this.loading = false;
    }
  }
});
